import { combineReducers } from "redux";
// import auth from "./reducers/auth"
// import installsreduce from "./reducers/installsreduce"

export default combineReducers({
  // auth,
  // installsreduce,

});
